module.exports = __webpack_public_path__ + "static/media/patient-story-avatar-marisa.c36d771a.svg";